import { Skeleton, Stack, Typography } from '@mui/material';

import { useAppStore } from '@/inertia/AppStore';
import { faGrip, faListUl } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useBreakpoints } from '@/Utility/hooks';
import { useEffect } from 'react';
import './Bar.less';

type Props = {
  isFallback?: boolean;
};

export const Bar = (props: Props) => {
  const barView = useAppStore((state) => state.barView);
  const setBarView = useAppStore((state) => state.setBarView);
  const barTitle = useAppStore((state) => state.barTitle);

  const { isMobile } = useBreakpoints();

  useEffect(() => {
    if (isMobile && barView === 'grid') {
      setBarView('list');
    }
  }, [isMobile]);

  return (
    <Stack direction="row" spacing={2} justifyContent="space-between" className="Bar">
      {props?.isFallback ? (
        <Skeleton variant="text" sx={{ p: '0.25em 1em', width: '100%' }} />
      ) : (
        <Typography variant="h6" sx={{ p: '0.25em 0.5em' }}>
          {/* Suggested Content */}
          {!!barTitle ? barTitle : 'Suggested Content'}
        </Typography>
      )}
      {!isMobile && (
        <button
          type="button"
          disabled={props?.isFallback}
          className="GridOrListBtn"
          onClick={() => setBarView(barView === 'list' ? 'grid' : 'list')}
        >
          <Stack flexDirection="row" justifyContent="center" alignContent="center" alignItems="center" gap={0.5}>
            <FontAwesomeIcon icon={barView === 'list' ? faGrip : faListUl} />
            <Typography variant="body1" fontWeight={500}>
              {barView === 'list' ? 'Grid' : 'List'}
            </Typography>
          </Stack>
        </button>
      )}
    </Stack>
  );
};

export default Bar;
